<template>
    <div :class="['manualSection', code]">
        <div href="#" :class="['list-group-item', 'list-group-item-' + state]">
            <slot name="pre"></slot>
            <h4>{{ state === 'success' ? '✓' : '— ' }}<a href="" @click.prevent="$emit('click')" >{{ header }}</a></h4>
            <slot name="comment"></slot>
        </div>
        <div class="subsection" v-show="open">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
        state: {
            type: String,
            default: 'danger'
        },
        code: {
            type: String,
            default: 'nocode'
        }
    }
}
</script>

<style scoped>
.subsection {
    padding-top: 10px;
    padding-bottom: 20px;
}
</style>
